import * as React from "react";
import type { SVGProps } from "react";
const SvgCleanUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#D3ECF8"
      d="m6.47 5.258-.03 1.665c-.01.555.432 1.014.987 1.024l18.98.34a3.362 3.362 0 0 1 1.782.55l14.161 9.278c.531.347 1.149.538 1.783.55l6.429.115a3.363 3.363 0 0 0 3.42-3.51l-.413-9.375a3.363 3.363 0 0 0-3.299-3.214L9.892 1.956A3.363 3.363 0 0 0 6.47 5.258Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M5.719 9.528a4.015 4.015 0 0 0-4.016 4.015v36.989a4.015 4.015 0 0 0 4.016 4.015h48.669a4.015 4.015 0 0 0 4.015-4.015V22.887a4.015 4.015 0 0 0-4.015-4.015H42.437a5.719 5.719 0 0 1-3.317-1.06l-10.59-7.54a4.015 4.015 0 0 0-2.329-.744H5.719ZM0 13.543a5.719 5.719 0 0 1 5.719-5.719H26.2c1.189 0 2.348.37 3.317 1.06l10.59 7.54c.68.485 1.494.745 2.329.745h11.951a5.719 5.719 0 0 1 5.719 5.718v27.645a5.719 5.719 0 0 1-5.719 5.718H5.718A5.719 5.719 0 0 1 0 50.532v-36.99Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M35.707 35.729c0-.47.381-.852.852-.852h26.59a.852.852 0 1 1 0 1.703h-26.59a.852.852 0 0 1-.852-.851Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M59.602 36.251v21.094c0 .8-.293 1.566-.816 2.131a2.683 2.683 0 0 1-1.97.883H42.89a2.683 2.683 0 0 1-1.97-.883 3.143 3.143 0 0 1-.816-2.13V36.25h19.5Zm-15.32 0v-3.013c0-.8.293-1.566.816-2.131a2.683 2.683 0 0 1 1.97-.883h5.57c.74 0 1.448.318 1.97.883.523.565.816 1.331.816 2.13v3.014"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M47.068 31.076c-.49 0-.976.21-1.345.609-.37.401-.59.959-.59 1.553V35.4h9.44v-2.162c0-.594-.22-1.152-.59-1.553a1.832 1.832 0 0 0-1.344-.609h-5.572Zm9.208 4.324v-2.162c0-1.005-.368-1.98-1.042-2.71a3.535 3.535 0 0 0-2.595-1.155h-5.572c-.987 0-1.919.424-2.595 1.156a3.994 3.994 0 0 0-1.042 2.709V35.4h-3.326a.852.852 0 0 0-.852.851v21.094c0 1.005.368 1.98 1.042 2.71a3.535 3.535 0 0 0 2.595 1.156h13.928c.987 0 1.92-.425 2.595-1.157a3.995 3.995 0 0 0 1.042-2.709V36.251a.852.852 0 0 0-.852-.851h-3.326Zm-15.32 1.703v20.242c0 .594.218 1.152.589 1.553.369.399.854.61 1.344.61h13.928c.49 0 .975-.211 1.344-.61.371-.401.59-.959.59-1.553V37.103H40.955Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M47.848 43.554c.47 0 .852.381.852.851v8.864a.852.852 0 1 1-1.704 0v-8.864c0-.47.381-.851.852-.851ZM53.166 43.554c.47 0 .851.381.851.851v8.864a.852.852 0 1 1-1.703 0v-8.864c0-.47.381-.851.852-.851ZM10.055 2.714a2.51 2.51 0 0 0-2.511 2.511v3.838H5.84V5.225a4.214 4.214 0 0 1 4.215-4.214h40.97a4.214 4.214 0 0 1 4.215 4.214V18.41h-1.704V5.225a2.51 2.51 0 0 0-2.51-2.51H10.054Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M23.737 62.259h-11.92c-.392 0-.579-.502-.296-.773 3.816-3.671 6.274-9.507 7.063-12.128 2.155-9.237 7.26-10.22 9.544-9.556 7.284 1.633 5.294 15.264 3.319 22.161a.41.41 0 0 1-.399.296h-3.117a.418.418 0 0 1-.419-.418v-3.905c0-.423-.555-.579-.775-.218l-2.643 4.34a.418.418 0 0 1-.357.2Z"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M28.31 39.095c2.063.47 3.459 1.797 4.34 3.562.873 1.747 1.254 3.937 1.339 6.224.17 4.58-.841 9.794-1.84 13.283a1.14 1.14 0 0 1-1.1.825H27.93a1.148 1.148 0 0 1-1.148-1.148v-2.793l-2.065 3.39c-.208.342-.58.551-.98.551h-11.92c-1.105 0-1.518-1.341-.803-2.03 3.677-3.536 6.085-9.213 6.864-11.79 1.105-4.718 2.99-7.446 5.003-8.894 2.003-1.441 4.071-1.567 5.429-1.18Zm-4.576 2.365c-1.646 1.184-3.388 3.56-4.44 8.064l-.005.023-.006.022c-.772 2.564-3.106 8.158-6.773 11.96H23.56l2.553-4.19c.603-.992 2.128-.564 2.128.597v3.593h2.569c.953-3.403 1.877-8.324 1.719-12.594-.081-2.186-.445-4.141-1.186-5.625-.729-1.46-1.81-2.444-3.376-2.796l-.022-.005-.022-.006c-.926-.27-2.541-.23-4.19.957Zm-.264 20.219v-.001Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="m30.768 22.327-3.624 15.139a1.761 1.761 0 1 0 3.428.81l3.543-15.158a1.72 1.72 0 0 0-3.347-.791Z"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M32.44 21.737a.99.99 0 0 0-.962.76l-3.623 15.139a1.031 1.031 0 1 0 2.006.474l3.544-15.158a.99.99 0 0 0-.964-1.215Zm-2.382.42a2.45 2.45 0 0 1 4.769 1.128l-3.544 15.158a2.491 2.491 0 1 1-4.848-1.147l3.623-15.14Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M23.009 54.98a.73.73 0 0 1 .25 1l-3.992 6.654a.73.73 0 1 1-1.252-.75l3.992-6.654a.73.73 0 0 1 1.002-.25ZM26.95 46.968a.73.73 0 0 1 .327.98l-1.33 2.66a.73.73 0 1 1-1.306-.652l1.33-2.661a.73.73 0 0 1 .979-.327Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCleanUp;
